module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['menu', _vm.theme]
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "files"
  }, [_vm._l((_vm.articleList.length), function(i) {
    return [_c('li', {
      class: {
        "current": _vm.articleList[i - 1].current
      }
    }, [_c('span', {
      on: {
        "click": function($event) {
          _vm.selectThis(i)
        }
      }
    }, [_vm._v(_vm._s(_vm.articleList[i - 1].content.split('\n')[0]))]), _vm._v(" "), (_vm.articleList.length > 1) ? _c('button', {
      staticClass: "delete-btn",
      on: {
        "click": function($event) {
          _vm.deleteThis(i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]) : _vm._e()])]
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "options"
  }, [_c('li', [_c('button', {
    staticClass: "add-one-btn",
    on: {
      "click": _vm.newArticle
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.htmlDataUrl,
      "download": _vm.titleHtml
    },
    on: {
      "mouseenter": function($event) {
        _vm.createUrl("html")
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-html5"
  }), _vm._v("\n\t\t\t\tSave as .html\n\t\t\t")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.mdDataUrl,
      "download": _vm.titleMd
    },
    on: {
      "mouseenter": function($event) {
        _vm.createUrl("md")
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("\n\t\t\t\tSave as .md\n\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "copy-right"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('img', {
    attrs: {
      "src": require("../../img/logo.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3afe48c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sideMenu.vue
// module id = 33
// module chunks = 0